import type { FieldErrors, FieldValues } from "react-hook-form";

export function flattenErrorMessages<
  TFieldValues extends FieldValues = FieldValues,
>(errors: FieldErrors<TFieldValues>): string[] {
  const out: string[] = [];

  const walk = (node: unknown): void => {
    if (!node) return;

    if (Array.isArray(node)) {
      for (const v of node) walk(v);
      return;
    }

    if (typeof node === "object") {
      const obj = node as Record<string, unknown>;

      // Single message
      if (typeof obj.message === "string" && obj.message.trim()) {
        out.push(obj.message);
      }

      // Multiple messages from validate: { types: { ruleA: "msg", ruleB: "msg" } }
      if (obj.types && typeof obj.types === "object" && obj.types !== null) {
        for (const v of Object.values(obj.types as Record<string, unknown>)) {
          if (typeof v === "string" && v.trim()) out.push(v);
        }
      }

      // Recurse into children (covers nested objects, arrays, and root.*)
      for (const [k, v] of Object.entries(obj)) {
        if (k === "message" || k === "types" || k === "ref" || k === "type")
          continue;
        walk(v);
      }
    }
  };

  walk(errors);
  return out;
}
